// extracted by css-extract-rspack-plugin
export default {"ActionList_LinkItem":"ChatReference-module__ActionList_LinkItem__xwef1","referenceMenuOverlay":"ChatReference-module__referenceMenuOverlay__Idk3k"};